module.exports = __webpack_public_path__ + "static/img/3.4572762.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/3.png
// module id = CGih
// module chunks = 0